/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Modal from '@components/Modal';
import Input from '@components/Input';
import Button from '@components/Button';
import { Container, Title, Label, Buttons } from './styles';

interface IProps {
  isOpen: boolean;
  initialEmail: string;
  onConfirm: (email: string) => void;
  onCancel: () => void;
}

const SendEmailDialog: React.FC<IProps> = ({
  isOpen,
  initialEmail,
  onConfirm,
  onCancel,
}) => {
  const [email, setEmail] = useState(initialEmail);

  if (!isOpen) return null;

  const handleConfirm = () => {
    const trimmedEmail = email.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(trimmedEmail)) {
      toast.error('Informe um e-mail válido.');
      return;
    }
    onConfirm(trimmedEmail);
  };

  return (
    <Modal onCloseRequest={onCancel} exitButton={false}>
      <Container>
        <Title>ENVIAR DOCUMENTO POR E-MAIL</Title>
        <Label>
          E-mail do Destinatário
          <Input
            type="text"
            value={email}
            onChange={(e: any) => setEmail(e.target.value)}
          />
        </Label>
        <Buttons>
          <Button type="button" onClick={onCancel}>
            Cancelar
          </Button>
          <Button type="button" onClick={handleConfirm}>
            Enviar
          </Button>
        </Buttons>
      </Container>
    </Modal>
  );
};

export default SendEmailDialog;
